import axios from "axios";
axios.defaults.baseURL = process.env.REACT_APP_JNTUA_APIS_BASE_URL;
const instance = axios.create({
  baseURL: axios.defaults.baseURL,
});
export default instance;
